import Vue from 'vue'
import Vuex from 'vuex'
import Form from "./modules/Form";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    Form
  }
})
